module.exports = __webpack_public_path__ + "assets/img/dailyBg.6a7f361d.png";